import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularSplitForward: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_split-forward"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="split-forward icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M15.78 3.73814C15.2766 3.55213 14.7234 3.55213 14.22 3.73814L9.91334 5.32973C9.81518 5.366 9.75 5.45958 9.75 5.56423V8.35743C9.25319 8.27799 8.7468 8.27799 8.25 8.35743V5.56423C8.25 4.83169 8.70625 4.17666 9.39337 3.92273L13.7001 2.33115C14.539 2.02113 15.461 2.02113 16.2999 2.33115L20.6066 3.92273C21.2937 4.17666 21.75 4.83169 21.75 5.56422V12.5818C21.2998 12.1924 20.7955 11.8638 20.25 11.6087V5.56422C20.25 5.45958 20.1848 5.366 20.0867 5.32973L15.78 3.73814ZM14.6066 11.122C14.8077 11.1963 14.989 11.3049 15.1449 11.4398C14.5713 11.6629 14.0372 11.965 13.556 12.3328L9.77995 10.9374C9.27662 10.7513 8.72338 10.7513 8.22005 10.9374L3.91334 12.5289C3.81518 12.5652 3.75 12.6588 3.75 12.7634V18.4335C3.75 18.5381 3.81518 18.6317 3.91334 18.668L8.22005 20.2596C8.72338 20.4456 9.27662 20.4456 9.77995 20.2596L11.3715 19.6714C11.5414 20.1507 11.7659 20.6042 12.0375 21.0244L10.2999 21.6665C9.46103 21.9766 8.53897 21.9766 7.70008 21.6665L3.39337 20.075C2.70625 19.821 2.25 19.166 2.25 18.4335V12.7634C2.25 12.0309 2.70625 11.3759 3.39337 11.122L7.70008 9.53037C8.53897 9.22035 9.46103 9.22035 10.2999 9.53037L14.6066 11.122ZM11.7318 13.2508C11.9924 13.1605 12.269 13.2223 12.4647 13.3893C12.0907 13.8468 11.7778 14.3563 11.5385 14.9053L9.74989 15.5251V18.2243C9.74989 18.6386 9.4141 18.9743 8.99989 18.9743C8.58567 18.9743 8.24989 18.6386 8.24989 18.2243V15.5255L5.76921 14.668C5.37772 14.5327 5.17006 14.1057 5.30538 13.7142C5.4407 13.3227 5.86776 13.115 6.25925 13.2503L8.99959 14.1976L11.7318 13.2508ZM11.7692 7.66804C11.3777 7.53272 11.1701 7.10565 11.3054 6.71417C11.4407 6.32268 11.8678 6.11502 12.2593 6.25034L14.9178 7.1693C14.9708 7.18761 15.0284 7.18759 15.0813 7.16924L17.7318 6.25084C18.1232 6.11522 18.5504 6.32256 18.686 6.71394C18.8216 7.10532 18.6143 7.53254 18.2229 7.66816L15.5725 8.58656C15.2017 8.71502 14.7986 8.71517 14.4278 8.58699L11.7692 7.66804ZM23 17.5C23 20.5376 20.5376 23 17.5 23C14.4624 23 12 20.5376 12 17.5C12 14.4624 14.4624 12 17.5 12C20.5376 12 23 14.4624 23 17.5ZM14.5 17C14.2239 17 14 17.2239 14 17.5C14 17.7761 14.2239 18 14.5 18L19.2929 18L17.6464 19.6464C17.4512 19.8417 17.4512 20.1583 17.6464 20.3536C17.8417 20.5488 18.1583 20.5488 18.3536 20.3536L20.8536 17.8536C21.0488 17.6583 21.0488 17.3417 20.8536 17.1464L18.3536 14.6464C18.1583 14.4512 17.8417 14.4512 17.6464 14.6464C17.4512 14.8417 17.4512 15.1583 17.6464 15.3536L19.2929 17L14.5 17Z" />
      </svg>
    </span>
  );
};

export { RegularSplitForward };
